import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FloatingFocusManager, } from "@floating-ui/react";
import classNames from "classnames";
const GRID_INTERVAL = 8;
export const CustomPopover = ({ context, getFloatingProps, refs, strategy, y, x, arrowRef, arrowX, arrowY, children, id, menuZIndex, popoverClassName, }) => {
    return (_jsx(FloatingFocusManager, Object.assign({ context: context, modal: false }, getFloatingProps(), { children: _jsxs("div", Object.assign({ ref: refs.setFloating, id: id, onClick: (e) => e.stopPropagation() }, getFloatingProps({
            className: classNames("rounded", "border", "border-solid", "border-border-subdued", "focus:outline-0", ["px-1", "py-0.5"], ["drop-shadow", "dark:drop-shadow-dark"], [
                "bg-background-primary",
                "dark:bg-background-tertiary-darkmode",
                "dark:border-border-subdued-darkmode",
            ], popoverClassName),
            style: {
                position: strategy,
                top: y !== null && y !== void 0 ? y : "",
                left: x !== null && x !== void 0 ? x : "",
                zIndex: menuZIndex,
            },
        }), { children: [children, _jsx("div", { ref: arrowRef, style: {
                        left: arrowX != null ? arrowX : "",
                        top: arrowY != null ? arrowY : "",
                        right: "",
                        borderWidth: GRID_INTERVAL,
                        borderStyle: "solid",
                        borderBottomColor: "transparent",
                        borderLeftColor: "transparent",
                        borderRightColor: "transparent",
                        bottom: GRID_INTERVAL * -2,
                    }, className: "absolute\n                      border-background-primary\n                      dark:border-background-tertiary-darkmode" })] })) })));
};
//# sourceMappingURL=CustomPopover.js.map